import api from '@/src/router/views/schedule/hotel/api'

const state = {
  roomList: [],
  loading: false,
  error: null,
}

const getters = {
  loading: (state) => state.loading,
  error: (state) => state.error,
}

const mutations = {
  SET_LOADING(state, status) {
    state.loading = status
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  SET_ROOMLIST(state, data) {
    state.roomList = data
  },
}

const actions = {
  // async fetchRoomList({ commit }, { productId, payload }) {
  //   commit('SET_LOADING', true)
  //   commit('SET_ERROR', null)
  //   try {
  //     const res = await api.room.getHotelBookings(productId, payload)
  //     commit('SET_ROOMLIST', res)
  //     return res
  //   } catch (err) {
  //     commit('SET_ERROR', err)
  //     throw err
  //   } finally {
  //     commit('SET_LOADING', false)
  //   }
  // },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
